export const PhuturePoolAbi = [
  {
    type: 'function',
    name: 'conversionRate',
    inputs: [{ name: 'wrapper', type: 'address', internalType: 'address' }],
    outputs: [{ name: '', type: 'uint256', internalType: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'convertToAssets',
    inputs: [
      { name: 'wrapper', type: 'address', internalType: 'address' },
      { name: 'shares', type: 'uint256', internalType: 'uint256' },
    ],
    outputs: [{ name: '', type: 'uint256', internalType: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'convertToShares',
    inputs: [
      { name: 'wrapper', type: 'address', internalType: 'address' },
      { name: 'amount', type: 'uint256', internalType: 'uint256' },
    ],
    outputs: [{ name: '', type: 'uint256', internalType: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'deposit',
    inputs: [
      { name: 'asset', type: 'address', internalType: 'Currency' },
      { name: 'amount', type: 'uint256', internalType: 'uint256' },
      { name: 'receiver', type: 'address', internalType: 'address' },
    ],
    outputs: [{ name: 'shares', type: 'uint256', internalType: 'uint256' }],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    name: 'infoOf',
    inputs: [{ name: 'wrapper', type: 'address', internalType: 'address' }],
    outputs: [
      { name: 'assets', type: 'uint128', internalType: 'uint128' },
      { name: 'supply', type: 'uint128', internalType: 'uint128' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'previewDeposit',
    inputs: [
      { name: 'asset', type: 'address', internalType: 'Currency' },
      { name: 'amount', type: 'uint256', internalType: 'uint256' },
    ],
    outputs: [{ name: '', type: 'uint256', internalType: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'previewRedeem',
    inputs: [
      { name: 'asset', type: 'address', internalType: 'Currency' },
      { name: 'shares', type: 'uint256', internalType: 'uint256' },
    ],
    outputs: [{ name: '', type: 'uint256', internalType: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'redeem',
    inputs: [
      { name: 'asset', type: 'address', internalType: 'Currency' },
      { name: 'shares', type: 'uint256', internalType: 'uint256' },
      { name: 'receiver', type: 'address', internalType: 'address' },
      { name: 'owner', type: 'address', internalType: 'address' },
    ],
    outputs: [{ name: 'amount', type: 'uint256', internalType: 'uint256' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'wrapperOf',
    inputs: [{ name: 'asset', type: 'address', internalType: 'Currency' }],
    outputs: [{ name: '', type: 'address', internalType: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'event',
    name: 'Deposit',
    inputs: [
      { name: 'caller', type: 'address', indexed: true, internalType: 'address' },
      { name: 'owner', type: 'address', indexed: true, internalType: 'address' },
      { name: 'asset', type: 'address', indexed: true, internalType: 'Currency' },
      { name: 'amount', type: 'uint256', indexed: false, internalType: 'uint256' },
      { name: 'shares', type: 'uint256', indexed: false, internalType: 'uint256' },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'Sync',
    inputs: [
      { name: 'asset', type: 'address', indexed: true, internalType: 'Currency' },
      { name: 'wrapper', type: 'address', indexed: true, internalType: 'address' },
      { name: 'assets', type: 'uint256', indexed: false, internalType: 'uint256' },
      { name: 'supply', type: 'uint256', indexed: false, internalType: 'uint256' },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'Withdraw',
    inputs: [
      { name: 'caller', type: 'address', indexed: true, internalType: 'address' },
      { name: 'receiver', type: 'address', indexed: true, internalType: 'address' },
      { name: 'owner', type: 'address', indexed: true, internalType: 'address' },
      { name: 'asset', type: 'address', indexed: false, internalType: 'Currency' },
      { name: 'amount', type: 'uint256', indexed: false, internalType: 'uint256' },
      { name: 'shares', type: 'uint256', indexed: false, internalType: 'uint256' },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'WrapperDeployed',
    inputs: [
      { name: 'asset', type: 'address', indexed: true, internalType: 'Currency' },
      { name: 'wrapper', type: 'address', indexed: true, internalType: 'address' },
    ],
    anonymous: false,
  },
  { type: 'error', name: 'PhuturePool__BadSender', inputs: [] },
  {
    type: 'error',
    name: 'PhuturePool__HighLoss',
    inputs: [
      { name: 'want', type: 'uint256', internalType: 'uint256' },
      { name: 'bought', type: 'uint256', internalType: 'uint256' },
    ],
  },
  { type: 'error', name: 'PhuturePool__NativeAmountMismatch', inputs: [] },
  {
    type: 'error',
    name: 'PhuturePool__WrapperExists',
    inputs: [{ name: 'asset', type: 'address', internalType: 'Currency' }],
  },
  {
    type: 'error',
    name: 'PhuturePool__WrapperNotExists',
    inputs: [{ name: 'asset', type: 'address', internalType: 'Currency' }],
  },
  { type: 'error', name: 'PhuturePool__ZeroAssets', inputs: [] },
  { type: 'error', name: 'PhuturePool__ZeroShares', inputs: [] },
]
